import InitialAlignment from '@/components/SvgIcons/CollaborationProcess/InitialAlignment';
import OfferAndContract from '@/components/SvgIcons/CollaborationProcess/OfferAndContract';
import PostProjectCollaboration from '@/components/SvgIcons/CollaborationProcess/PostProjectCollaboration';
import ProjectCollaboration from '@/components/SvgIcons/CollaborationProcess/ProjectCollaboration';
import colors from '@/styles/themes/colors';

export interface CollaborationProcessItem {
  icon: React.ElementType;
  color: string;
  title: string;
  features: string;
  bulletColor: 'blue' | 'green' | 'orange' | 'pink';
}

export const collaborationProcess: CollaborationProcessItem[] = [
  {
    icon: InitialAlignment,
    color: colors.blue500,
    title: 'items.initialAlignment.title',
    features: 'items.initialAlignment.features',
    bulletColor: 'blue',
  },
  {
    icon: OfferAndContract,
    color: colors.green400,
    title: 'items.offerAndContract.title',
    features: 'items.offerAndContract.features',
    bulletColor: 'green',
  },
  {
    icon: ProjectCollaboration,
    color: colors.pink600,
    title: 'items.projectCollaboration.title',
    features: 'items.projectCollaboration.features',
    bulletColor: 'pink',
  },
  {
    icon: PostProjectCollaboration,
    color: colors.orange500,
    title: 'items.postProjectCollaboration.title',
    features: 'items.postProjectCollaboration.features',
    bulletColor: 'orange',
  },
];
